import { Observable } from 'rxjs/Rx';
import { FormBuilder } from '@angular/forms';
import { Activity, ActivityApi, DataelementApi, EntityApi, LoopBackAuth } from '../../../sdk';
import { OnInit, Input, Component } from '@angular/core';
import { AbstractWidgetComponent, getFieldFromArray, isNotEmpty } from '../../../utils/util';
import * as _ from 'lodash';
import * as moment from 'moment';
import { PushNotificationsService, NotificationsService } from 'angular2-notifications';
import { PlatformApp } from '../../../services/app.service';
@Component({
    selector: 'eventschart-widget',
    templateUrl: './eventschart.component.html',
    styleUrls: ['./eventschart.component.scss']
})
export class EventsChartComponent extends AbstractWidgetComponent implements OnInit {
    id = 'eventschart' + Math.floor((Math.random() * 1000000000000) + 1);
    @Input() title = '';
    ddd = false;
    @Input() widget: any;
    _dataelementid = '';
    _comparefields = [];
    _basefield = '';
    _RANGE_PATTERN = /^(last)?(\d{1})([year|month|week|day]*)s?$/gi;
    _startDate: Date;
    _endDate: Date;
    _rangeFieldName: string;
    notifyOptions = PlatformApp.getNotificationOptions();
    constructor(_dataelementApi: DataelementApi,
        fb: FormBuilder, _loopBackAuth: LoopBackAuth,
        private _NotificationsService: NotificationsService, private _PushNotificationsService: PushNotificationsService,
        private _activityApi: ActivityApi, _entityApi: EntityApi) {
        super(_dataelementApi, fb, _loopBackAuth, _entityApi);
    }

    ngOnInit() {
        if (this.widget) {
            this._dataelementid = this.widget.dataelement;
            this.ddd = this.widget.ddd ? Boolean(this.widget.ddd) : this.ddd;
            this.autorefresh = this.widget.autorefresh ? Boolean(this.widget.autorefresh) : this.autorefresh;
            this._basefield = this.widget.basefield;
            this._comparefields = isNotEmpty(this.widget.comparefields) ? this.widget.comparefields : [this.widget.comparefield];
            if (isNotEmpty(this.widget.filterfields)) {
                this.filter_fields = _.cloneDeep(this.widget.filterfields);
            }
            this._rangeFieldName = this.widget.rangefield;
            if (this.widget.range) {
                this._setRange(this.widget.range);
            }
            this.title = this.widget.title;
        }
        this.options = this.createChartConfig();
        this.setChartConfig();
    }

    _setRange(range: string): void {
        let result = this._RANGE_PATTERN.exec(range);
        let isPast = false;
        let periodCount = 1;
        let period = 'years';
        if (result) {
            isPast = result[1] ? true : false;
            periodCount = isPast ? Number(result[2]) : Number(result[2]) / 2;
            period = result[3];
        }
        let momentInp: moment.MomentInput = { years: periodCount };
        switch (period) {
            case 'month':
                momentInp = { months: periodCount };
                break;
            case 'week':
                momentInp = { weeks: periodCount };
                break;
            case 'day':
                momentInp = { days: periodCount };
                break;
        }
        if (isPast) {
            this._startDate = moment().subtract(momentInp).toDate();
            this._endDate = moment().toDate();
        } else {
            this._startDate = moment().subtract(momentInp).toDate();
            this._endDate = moment().add(momentInp).toDate();
        }
        this.internal_filter = [{
            'fieldtype': 'date',
            'filtertype': 'between',
            'label': 'Range Date',
            'name': this._rangeFieldName,
            'selected_v': [this._startDate, this._endDate]
        }];
    }

    getWidgetData() {
        this.widgetData()
            .flatMap(result => this.getEvents().map(events => {
                result['events'] = events;
                return result;
            }))
            .subscribe(result => {
                if (result) {
                    this.filter_fields = _.cloneDeep(result['filterfields']);
                    this.options = this.createChartConfig(result);
                }
            }, err => console.error(err));
    }

    getEvents(): Observable<Array<Activity>> {
        if (this.appid === '5825d19bf009c4bc37fd7ba0') {
            let filter = {
                'where': {
                    'appId': this.appid,
                    'Type': 'event',
                    'Subtype': 'investment',
                    'entityId': '583327789137b2700a1621fb' // TODO all card coding should be removed
                },
                'fields': ['Subject', 'ActivityDate', 'entityrecordId', 'EventType', 'Status']
            };
            if (this._startDate && this._endDate) {
                filter.where['ActivityDate'] = { 'between': [this._startDate, this._endDate] };
            }
            return this._activityApi.find(filter);
        } else {
            Observable.of(null);
        }
    }

    createChartConfig(dataelement?) {
        let options = {
            'type': 'stock',
            'theme': 'light',
            'dataSets': [{
                //'color': '#b0de09',
                'fieldMappings': [],
                'dataProvider': [],
                'categoryField': this._basefield,
                // EVENTS
                'stockEvents': []
            }],
            'panels': [],
            'chartScrollbarSettings': {
                'graph': 'g1'
            },
            'chartCursorSettings': {
                'valueBalloonsEnabled': true,
                'graphBulletSize': 1,
                'valueLineBalloonEnabled': true,
                'valueLineEnabled': true,
                'valueLineAlpha': 0.5
            },
            'periodSelector': {
                'periods': [{
                    'period': 'DD',
                    'count': 10,
                    'label': '10 days'
                }, {
                    'period': 'MM',
                    'count': 1,
                    'label': '1 month'
                }, {
                    'period': 'YYYY',
                    'count': 1,
                    'label': '1 year'
                }, {
                    'period': 'YTD',
                    'label': 'YTD'
                }, {
                    'period': 'MAX',
                    'label': 'MAX'
                }]
            },
            'panelsSettings': {
                'usePrefixes': true
            }
        };
        this._comparefields.forEach((cf, index) => {
            options.dataSets[0].fieldMappings.push({ 'fromField': cf, 'toField': cf });
            options.panels.push({
                'title': cf,
                'stockGraphs': [{
                    'id': 'g' + index,
                    'valueField': cf,
                    'fillAlphas': 0.7,
                }],
                'stockLegend': {
                    'valueTextRegular': ' ',
                    'markerType': 'none'
                }
            });
        });
        if (dataelement) {
            options.dataSets[0].dataProvider = dataelement.data;
            options['title'] = this.title;
            this._comparefields.forEach((cf, index) => {
                let cfield = getFieldFromArray(dataelement.fields, cf);
                if (cfield) {
                    options.panels[index].title = cfield.label;
                }
            });
            if (isNotEmpty(dataelement.events)) {
                dataelement.events.forEach(event => {
                    let eve = {
                        'graph': 'g0',
                        'date': event.ActivityDate,
                        'type': event.Status === 'completed' ? 'pin' : 'sign',
                        'backgroundColor': '#E0F2F8',
                        'text': event.Status === 'completed' ? 'I' : 'M',
                        'description': event.Subject
                    };
                    if (typeof event.ActivityDate === 'string') {
                        eve.date = new Date(event.ActivityDate);
                    }
                    switch (event.Status) {
                        case 'completed':
                            eve.backgroundColor = '#7AFF4B';
                            break;
                        case 'open':
                            eve.backgroundColor = '#FF7F7F';
                            break;
                    }
                    options.dataSets[0].stockEvents.push(eve);
                });
            }
        }
        //console.log('options:-', JSON.stringify(options));
        return options;
    }

    notify(type, title?, content?, options?) {
        if (!options) options = PlatformApp.getNotificationOptions();
        if (!options.id) options.id = type + '-' + title + '_' + content;
        switch (type) {
            case 'success': this._NotificationsService.success(title, content, options); break;
            case 'alert': this._NotificationsService.alert(title, content, options); break;
            case 'error': this._NotificationsService.error(title, content, options); break;
            case 'info': this._NotificationsService.info(title, content, options); break;
            case 'bare': this._NotificationsService.bare(title, content, options); break;
            default: this._NotificationsService.info(title, content, options);
        }
    }
}


// WEBPACK FOOTER //
// ./src/app/shared/components/widgets/eventschart/eventschart.component.ts